import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import { awaitTimeout } from "@/utils/GlobalJavascriptFunction";
export var api__bulkAddRecentViewCars = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(listOfIdTime) {
    var params, cacheKey, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!__IS_SSR__) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          params = {
            posts: listOfIdTime
          };
          cacheKey = JSON.stringify(listOfIdTime === null || listOfIdTime === void 0 ? void 0 : listOfIdTime.map(function (item) {
            return item.post_id;
          }));
          window.__FIXME_BLOCK_PROMISE_1 = window.__FIXME_BLOCK_PROMISE_1 || {};
          window.__FIXME_CACHE_API_1 = window.__FIXME_CACHE_API_1 || {};
          if (!window.__FIXME_BLOCK_PROMISE_1[cacheKey]) {
            _context.n = 2;
            break;
          }
          _context.n = 2;
          return awaitTimeout(2000);
        case 2:
          if (!window.__FIXME_CACHE_API_1[cacheKey]) {
            _context.n = 3;
            break;
          }
          return _context.a(2, window.__FIXME_CACHE_API_1[cacheKey]);
        case 3:
          window.__FIXME_BLOCK_PROMISE_1[cacheKey] = true;

          // Make the GET request with query parameters
          _context.n = 4;
          return fetcher(null, true).post("/customer/bulk-add-recent-view-cars", params);
        case 4:
          res = _context.v;
          // Return the response data
          window.__FIXME_CACHE_API_1[cacheKey] = res.data;
          window.__FIXME_BLOCK_PROMISE_1[cacheKey] = undefined;
          return _context.a(2, res.data);
      }
    }, _callee);
  }));
  return function api__bulkAddRecentViewCars(_x) {
    return _ref.apply(this, arguments);
  };
}();